exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cart-comp:not(.active) .cart{display:none}.cart-comp .cart{top:calc(100% + 24px);width:320px;right:0;padding:0 12px;border-width:1px;border-style:solid}.cart-comp .cart .items .item,.cart-comp .cart footer{padding:12px 0}.cart-comp .cart .items .item{border-bottom-width:1px;border-bottom-style:solid}", ""]);

// exports
